import Vue from 'vue';
import Vuex from 'vuex';
import AppConfig from '@/config';
import app from './modules/app';
import auth from './modules/auth';
import createLogger from './plugins/logger';
import { mutations as $M } from './types';


Vue.use(Vuex);

const plugins = [];
if (!AppConfig.env.production && AppConfig.logging.mutations) plugins.push(createLogger({
    filter: (mutation) => {
        return mutation.type !== $M.AUTH_TIME_UPDATE;
    }
}));

export const store = new Vuex.Store({
    strict: !AppConfig.env.production,
	plugins,
	modules: {
		app,
		auth
	}
});


// Exports
export { getters, actions, mutations } from './types';
export default store;
